import { DrofusChangeEventDetails } from "../DrofusEndringer/DrofusChangeEventDetails";
import { Alert, Badge, Group, Modal, Stack, Text } from "@mantine/core";
import type { DrofusForekomstDetailsRef as IOccurrenceDetailsRef } from "./DrofusForekomstDetailsModal";

interface IRemovedDrofusOccurrenceDetailsProps {
  occurrenceRef: IOccurrenceDetailsRef;
  opened: boolean;
  onClose: () => void;
}
const formatTime = (value?: string | null) => {
  if (!value) return "Ikke registrert";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString("nb-NO");
};

export const RemovedDrofusOccurrenceDetails: React.FC<IRemovedDrofusOccurrenceDetailsProps> = ({
  occurrenceRef,
  opened,
  onClose,
}) => {
  const event = occurrenceRef.removedChange;
  if (!event) return null;
  const { article, room, occurrence } = event.context;
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={`Fjernet forekomst ${occurrenceRef.occurrenceId}`}
      size="lg"
    >
      <Stack gap="md">
        <Alert color="orange" title="Historisk informasjon">
          Forekomsten er registrert som fjernet mellom to innlesninger. Her vises opplysningene som
          er lagret i endringshistorikken.
        </Alert>
        {occurrenceRef.changeEvent ? (
          <DrofusChangeEventDetails event={occurrenceRef.changeEvent} />
        ) : (
          <>
            <Stack gap={4}>
              <Text fw={700} style={{ overflowWrap: "anywhere" }}>
                {article?.name || "Artikkelnavn ikke registrert"}
              </Text>
              <Text size="sm">Artikkelnummer: {article?.compCode || "Ikke registrert"}</Text>
              <Text size="sm">
                Rom:{" "}
                {[room?.functionNo, room?.fullName].filter(Boolean).join(" · ") ||
                  "Ikke registrert"}
              </Text>
              <Text size="sm">
                MMI ved siste registrering: {occurrence?.mmiCode || "Ikke angitt"}
              </Text>
            </Stack>
            <Group gap="xs">
              {event.affectedDisciplines.map((discipline) => (
                <Badge key={discipline} variant="light">
                  {discipline}
                </Badge>
              ))}
            </Group>
            <Stack gap={4}>
              <Text size="sm">Oppdaget ved innlesning: {formatTime(event.runStartedAt)}</Text>
              <Text size="sm">Loggdato i dRofus: {formatTime(event.drofusLog?.time)}</Text>
              <Text size="sm">
                Bruker i tilknyttet dRofus-logg: {event.drofusLog?.username || "Ikke registrert"}
              </Text>
            </Stack>
          </>
        )}
      </Stack>
    </Modal>
  );
};
